module.exports = __webpack_public_path__ + "img/logo-8.00288e68.png";